import { Box, Icon } from '@petsmart-ui/sparky';

import { FREE_SHIPPING_THRESHOLD_US_CA } from '../../constants/freeShipping';
import { CountdownBar } from './CountdownBar';
import { CountdownHelper } from './CountdownHelper';
import { CountdownTitle } from './CountdownTitle';

import './CountdownMeter.scss';

export type CountdownCardProps = {
    readonly qualifyingSubtotal: number;
    readonly isLoggedIn: boolean;
};

export const CountdownCard = ({ qualifyingSubtotal, isLoggedIn }: CountdownCardProps) => {
    const amountAway = Math.max(0, FREE_SHIPPING_THRESHOLD_US_CA - qualifyingSubtotal);
    const progressTowardThreshold = Math.min(Math.max(0, qualifyingSubtotal), FREE_SHIPPING_THRESHOLD_US_CA);

    return (
        <Box styleModifier="flush" className="countdown-card" data-testid="countdown-card">
            <div className="countdown-card__section">
                <div className="countdown-card__header">
                    <Icon size="md" className="countdown-card__icon" name="box-outline" />
                    <CountdownTitle amountAway={amountAway} isLoggedIn={isLoggedIn} />
                </div>
                <div className="sparky-u-margin-top-xs">
                    <CountdownBar
                        value={progressTowardThreshold}
                        total={FREE_SHIPPING_THRESHOLD_US_CA}
                        startLabel="$0"
                        endLabel="$49"
                    />
                </div>
                {!isLoggedIn && <CountdownHelper />}
            </div>
        </Box>
    );
};
